/**
 * 封装tree格式
 * @param data
 * @returns {Array}
 */
export const getTree = (data) => {
  // 删除 所有 children,以防止多次调用
  data.forEach(function (item) {
    delete item.children
  })

  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  let map = {}
  data.forEach(function (item) {
    map[item.id] = item
  })
  //        console.log(map);
  let val = []
  data.forEach(function (item) {
    delete item.id
    delete item.createdAt
    delete item.updatedAt
    // delete item.indexId
    delete item.role_name
    delete item.size
    delete item.status
    delete item.level
    // 以当前遍历项，的pid,去map对象中找到索引的id
    let parent = map[item.parentId]
    if (parent) item.path = ('/' + parent.path + '/' + item.path).replace('//', '/')
    // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      (parent.children || (parent.children = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}
/**
 * 封装tree格式
 * @param data
 * @returns {Array}
 */
export const getTree2 = (data) => {
  // 删除 所有 children,以防止多次调用
  data.forEach(function (item) {
    delete item.children
  })
  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  let map = {}
  data.forEach(function (item) {
    map[item.id] = item
  })
  //        console.log(map);
  let val = []
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    let parent = map[item.parentId]
    if (parent) item.path = ('/' + parent.path + '/' + item.path).replace('//', '/')
    // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      (parent.children || (parent.children = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}
/**
 * 对象数组排序
 * @param data
 * @returns {Array}
 */
export const objArrSort = (p) => {
  return function (m, n) {
    let a = m[p]
    let b = n[p]
    return a - b // 升序
  }
}

// 合并不同数组组合
export const mergeArrComb = (arr) => {
  var len = arr.length;
  // 当数组大于等于2个的时候
  if (len >= 2) {
    // 第一个数组的长度
    var len1 = arr[0].length;
    // 第二个数组的长度
    var len2 = arr[1].length;
    // 2个数组产生的组合数
    var lenBoth = len1 * len2;
    //  申明一个新数组,做数据暂存
    var items = new Array(lenBoth);
    // 申明新数组的索引
    var index = 0;
    // 2层嵌套循环,将组合放到新数组中
    for (var i = 0; i < len1; i++) {
      for (var j = 0; j < len2; j++) {
        items[index] = arr[0][i] + "|" + arr[1][j];
        index++;
      }
    }
    // 将新组合的数组并到原数组中
    var newArr = new Array(len - 1);
    for (var i = 2; i < arr.length; i++) {
      newArr[i - 1] = arr[i];
    }
    newArr[0] = items;
    // 执行回调
    return mergeArrComb(newArr);
  } else {
    return arr[0];
  }
}



// WEBPACK FOOTER //
// ./src/libs/arrayUtil.js